module.exports = __webpack_public_path__ + "assets/img/buzhou_wancheng@2x.aab62ef0.png";